import React from "react";
import { useSelector, shallowEqual } from "react-redux";
import { HelpTipContext } from "./HelpTipContext";

const HelpTipProvider = ({ children }) => {
  const helpTipsList = useSelector(
    (state) => state.get_help_tips_by_module.data || [],
  );

  const isFetching = useSelector(
    (state) => state.get_help_tips_by_module.isFetching,
  );

  return (
    <HelpTipContext.Provider value={{ helpTipsList, isFetching }}>
      {children}
    </HelpTipContext.Provider>
  );
};

export default HelpTipProvider;
